export default function fancybox() {
    if(document.querySelector("[data-fancybox='video-about']")){
        Fancybox.bind("[data-fancybox='video-about']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox='video-about-news']")){
        Fancybox.bind("[data-fancybox='video-about-news']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox^='gallery-about-']")){
        Fancybox.bind("[data-fancybox^='gallery-about-']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

}